import { render, staticRenderFns } from "./ykc-form-item.vue?vue&type=template&id=e6fba1d6&"
import script from "./ykc-form-item.vue?vue&type=script&lang=js&"
export * from "./ykc-form-item.vue?vue&type=script&lang=js&"
import style0 from "./ykc-form-item.vue?vue&type=style&index=0&id=e6fba1d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports